import React, { useState, useEffect, Children } from 'react';
interface Props {
  children : ReactNode
}

export function MarqueeWidget(props : Props) {

  return (
    <marquee scrollamount="20" style={{fontSize: "24px"}} >{props.children}</marquee>
  );
}